"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_admin_1 = require("react-admin");
var react_1 = __importDefault(require("react"));
var ReactAdminError_1 = __importDefault(require("@/Components/common/ReactAdmin/ReactAdminError"));
var RALayout = function (props) {
    return react_1.default.createElement(react_admin_1.Layout, __assign({ sx: {
            "& .RaLayout-appFrame": {
                marginTop: 0,
            },
            "& .RaLayout-content": {
                padding: 0,
                background: "#f8f8f8",
                position: "relative",
            },
            "& .css-gp0tzt-MuiToolbar-root-RaTopToolbar-root": {
                visibility: "hidden",
            },
            "& .RaLayout-contentWithSidebar": {
                background: "#f8f8f8"
            },
            "& .skip-nav-button": {
                display: "none",
            },
        } }, props, { appBar: function () { return null; }, menu: function () { return null; }, sidebar: function () { return null; }, error: ReactAdminError_1.default, style: { minHeight: "unset" } }));
};
exports.default = RALayout;
